import styled from 'styled-components';
import { Divider } from '~/components/ui/Divider';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;

	${Divider} {
		opacity: 0.1;
	}
`;

const StyledTopContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export { StyledContainer, StyledTopContainer };
